import styled from 'styled-components/macro';

export const DelColButton = styled.button`
  height: auto;
  width: auto;
  margin-left: 20px;
  background-color: Transparent;
  border: none;
  cursor:pointer;
  padding: 0;
  display: inline-block;
  vertical-align: middle;
`

export const MatchContainer = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Card = styled.div`
  height: auto;
  max-width: 300px;
  border-image-slice: 1;
  color: ${props =>( props.match ?
    `green` : `red`
  )};
  margin: 2em;
  padding: 14px;
  border-radius: 50px;
  background: #F5F5F5;
  box-shadow: 0px 0px 4px;
  font-weight: 600;
  font-size: 18px;
`
